import { VueExtension } from '../../utils/extensions/vue';
import Empty from './empty.jsx';
import './empty.scss';

VueExtension.WithInstall(Empty);

export default Empty;
